import { ContactSectionProps } from '../modules/checkout/contact-section'
import { Storage } from '../storage'
import { EventState, EventView } from '../types'

const getEmailError = (state: EventState): string | undefined => {
    const { lang, validationErrors } = state

    switch (validationErrors.email) {
        case 'card-mismatch':
            return lang.contact_email_card_mismatch

        case 'required':
        case 'invalid':
            return lang.contact_email_invalid
    }
}

export const getContactSection = (view: EventView): ContactSectionProps => {
    const { state } = view
    const { lang, validationErrors } = state

    const result: ContactSectionProps = {
        title: lang.contact_title,
        text: lang.contact_description,
        name: {
            id: 'name',
            label: lang.contact_name,
            isRequired: true,
            value: Storage.get('name'),
            onChange: (value: string) => {
                Storage.update({ name: value })
                delete state.validationErrors.name
                view.update()
            },
            error: validationErrors.name ? lang.contact_name_invalid : undefined,
        },
        email: {
            type: 'email',
            id: 'email',
            label: lang.contact_email,
            isRequired: true,
            value: Storage.get('email'),
            onChange: (value: string) => {
                Storage.update({ email: value })
                delete state.validationErrors.email
                view.update()
            },
            error: getEmailError(state),
        },
        phone: {
            type: 'tel',
            id: 'phone',
            label: lang.contact_phone,
            value: Storage.get('phone'),
            onChange: (value: string) => {
                Storage.update({ phone: value })
                delete state.validationErrors.phone
                view.update()
            },
        },
    }

    if (view.state.hasNewsletterCheckbox) {
        if (view.state.newsletterCheckedByDefault && Storage.get('newsletter') === '') {
            Storage.update({ newsletter: 'yes' })
        }

        result.newsletter = {
            label: lang.contact_newsletter,
            checked: Storage.get('newsletter') === 'yes',
            onChange: (value: boolean) => {
                Storage.update({ newsletter: value ? 'yes' : 'no' })
                delete state.validationErrors.newsletter
                view.update()
            },
        }
    }

    return result
}
